document.addEventListener("DOMContentLoaded", function () {
  const mobileHeader = document.querySelector("#shopify-section-sections--15666946932839__header-mobile > sticky-header-mobile > div");

  if (mobileHeader) {
    const languageDropdown = document.createElement("div");
    languageDropdown.className = "language-switcher-mobile";
    languageDropdown.innerHTML = `
      <select id="language-select-mobile" aria-label="Select Language">
        <option value="en" ${Shopify.locale === 'en' ? 'selected' : ''}>English</option>
        <option value="ar" ${Shopify.locale === 'ar' ? 'selected' : ''}>العربية</option>
      </select>
    `;
    mobileHeader.appendChild(languageDropdown);

    const langSelect = document.getElementById("language-select-mobile");
    langSelect.addEventListener("change", function () {
      const selectedLocale = langSelect.value;
      const url = new URL(window.location.href);
      const segments = url.pathname.split('/').filter(Boolean);
      if (segments.length > 0 && ['en', 'ar'].includes(segments[0])) {
        segments.shift();
      }
      url.pathname = (selectedLocale === 'en' ? '/' : '/' + selectedLocale + '/') + segments.join('/');
      window.location.href = url.toString();
    });
  }
});
